<div class="fixed top-0 right-0 z-100 w-full max-sm:max-w-[98%] sm:w-[500px]" [ngClass]="{'h-full': notifications.length}">
    @for (notification of notifications; track notification.id) {
        <div class="sm:mr-3 relative overflow-hidden">
            <!-- require modification - bg-colors for dark theme -->
            <div class="flex flex-row w-[96%] sm:w-[488px] mt-4 py-3 rounded-md border-l-[5px] items-center overflow-hidden" [ngClass]="{
                    'border-[var(--accent-success)] bg-[var(--bg-success)] ': notification.type === 0,
                    'border-[var(--accent-warning)] bg-[var(--bg-warning)] ': notification.type === 1 || notification.type >= 4,
                    'border-[var(--accent-error)] bg-[var(--bg-error)] ': notification.type === 2,
                    'border-[var(--accent-info)] bg-[var(--bg-info)] ': notification.type === 3,
                }">

                <svg-icon class="mx-3" [name]="notification.style.icon" size="LG" [color]="notification.style.iconColor">
                </svg-icon>

                <div class="flex flex-col w-[86%] relative">
                    <h1 class="title text-base sm:text-lg" [ngClass]="{
                        'text-[var(--accent-success)] ': notification.type === 0,
                        'text-[var(--accent-warning)] ': notification.type === 1 || notification.type >= 4,
                        'text-[var(--accent-error)] ': notification.type === 2,
                        'text-[var(--accent-info)] ': notification.type === 3,
                    }">{{ notification?.title }}</h1>

                    <p class="text-wrap break-words  text-sm sm:text-lg">
                        {{ notification.message }}
                    </p>

                    <div class="flex flex-row gap-2 mt-1 sm:gap-4 justify-end"
                        [ngClass]="{'pointer-events-none grayscale': delay[notification.id]}">

                        @if (notification.type === 5) {
                            <common-button theme="pumpkin" icon="arrow_full" [reversed]="true"
                                [size]="(isMobile$ | async) ? 'S' : 'L'"
                                iconSize="XL" class="place-self-end" (click)="close(notification)">No
                            </common-button>
                        }

                        @if (notification.type >= 4) {
                            <common-button theme="pumpkin" icon="arrow_full" [reversed]="true"
                                [size]="(isMobile$ | async) ? 'S' : 'L'"
                                iconSize="XL" class="place-self-end" (click)="confirm(notification)">Proceed
                            </common-button>
                        }
                    </div>
                </div>

                @if (notification.type !== 5) {
                    <svg-icon class="grow mt-1 cursor-pointer self-start justify-self-end mr-2 sm:mr-0" name="close" size="XS"
                        color="var(--secondary-color)" (click)="close(notification)">
                    </svg-icon>
                }
            </div>

            @if (notification.type === 5 && delay[notification.id]) {
                <div class="absolute bottom-0 rounded-b-lg mt-4 h-[5px] w-full
                        bg-[length:40px_100%]
                        bg-[repeating-linear-gradient(45deg,var(--accent-warning)_0px,var(--accent-warning)_10px,transparent_10px,transparent_20px)]
                        animate-striped-progress">
                </div>
            }
        </div>
    }
</div>
